import React from 'react'
import classnames from 'classnames'
import { handleClassNames } from '../HOC'

class ConfirmButton extends React.PureComponent {
  render () {
    const { type, className, ...props } = this.props
    return <div className={classnames(className, 'confirm-button', {
      'confirm-button--danger': type === 'danger',
      'confirm-button--warning': type === 'warning',
      'confirm-button--invalid': type === 'invalid'
    })}
      {...props}
    />
  }
}

@handleClassNames('footer-button')
class FooterButton extends React.PureComponent {
  render () {
    const { icon, children, ...props } = this.props
    return <div {...props}>
      <i className={`footer-button__icon icon-font ${icon}`} />
      <span className={'footer-button__text'}>{children}</span>
    </div>
  }
}

export {
  FooterButton,
  ConfirmButton
}
